import { defineStore } from 'pinia'
import axios from 'axios'
import config from '@/utils/config'
import { createSingleFlightLoader } from './singleFlightLoader'
import { isAdministrator } from '@/views/AuthorityManagement/userRolePolicy'

export interface UserInfo {
  userId: string
  userName: string
  companyName: string
  jobResponsibility: string
  team: string
  avatar: string | null
  role: string
  status: string
  remark: string | null
  queryDays?: number | null
  exportLimit?: number | null
  mediaCooperationAmount?: number

  //监测中心权限
  monitorDashboard?:number
  monitorDetails?:number
  monitorContent?:number
  //任务中心权限
  taskInternal?:number
  taskMonitor?:number
  taskArchive?:number
  //媒体中心权限
  mediaList?:number
  mediaDetails?:number
  mediaResources?:number
  mediaServicer?:number
  mediaAuthority?:number
  //成本中心权限
  costDashboard?:number
  costDetails?:number
  budgetAllocation?:number




}

const userInfoLoader = createSingleFlightLoader<Partial<UserInfo>>()

type State = {
  info: Partial<UserInfo>
  initialized: boolean
}

export const useUserStore = defineStore('user', {
  state: (): State => ({
    info: {},
    initialized: false,
  }),
  getters: {
    userId: (s) => s.info.userId || '',
    role: (s) => s.info.role || '',
    isAdmin(): boolean {
      const r = this.role as string
      return isAdministrator(r) || r?.toLowerCase() === 'admin'
    },
    name: (s) => s.info.userName || '',
    companyName: (s) => s.info.companyName || '',
    avatarUrl: (s) => (s.info.avatar as string) || '',
    hasModuleAuth:(s)=>(moduleName:string)=>{
      const level=(s.info as any)[moduleName] ||0;
      return level>=1;
    }

  },
  actions: {
    async fetchUserInfo(force = false) {
      if (this.initialized && !force) return
      return userInfoLoader.load(async () => {
        const baseUrl = config.BASE_URL || ''
        const url = `${baseUrl}/userinfo/info?_=${Date.now()}`
        const { data } = await axios.get(url, {
          withCredentials: true,
          headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' },
        })
        const envelope = data && typeof data === 'object' && 'data' in data ? data.data : data
        if (!envelope || typeof envelope !== 'object') {
          throw new Error('用户信息响应无效')
        }
        return {
          ...(envelope.user || {}),
          ...(envelope.permissions || {}),
        } as Partial<UserInfo>
      }, (info) => {
        this.info = info
        this.initialized = true
      })

    },
    getUserId() {
      return this.userId
    },
    getRole() {
      return this.role
    },
    reset() {
      userInfoLoader.reset()
      this.info = {}
      this.initialized = false
    },
  },
})
